import { EnvironmentSpecific } from "./environment.interface";

const website = "https://citychallenge.app";
export const citychallenge: EnvironmentSpecific = {
  identifier: "app.citychallenge",
  hasAuthentication: true,
  iosAppstoreId: "1464999195",
  calendarColor: "green",
  type: "geographic",
  website,
  environmentName: "citychallenge",
  contact: `${website}/contact`,
  name: "City Challenge",
  youtube: "https://www.youtube.com/channel/UCAfam-3IaodMNCIkZTjJ76Q",
  instagram: "https://www.instagram.com/citychallengeamsterdam/",
  facebook: "https://www.facebook.com/citychallengeamsterdam/",
  terms: `${website}/terms-of-use`,
  privacy: `${website}/privacy-policy`,
  oneSignalAppId: "543db2d5-c290-4ac1-8e74-97c0404821d4",
};
